import { Link } from "react-router";
import { useTranslation } from "react-i18next";
import "../../i18n";
import { Notice } from "../../design/components";
import { useDashboardSummary, useEntities } from "../../api/queries";
import { dateTime } from "../../lib/format";
import { AspHealthCard } from "./AspHealthCard";
import { HealthTable } from "./HealthTable";
import { StageStrip } from "../documents/StageStrip";
import { StatRow } from "./StatRow";
import styles from "./GroupDashboard.module.css";

export function GroupDashboard() {
  const { t } = useTranslation();
  const summary = useDashboardSummary();
  const entities = useEntities();
  const data = summary.data;

  return (
    <>
      <div className="page-head">
        <div className="grow">
          <h1 className="display">{t("dashboard.groupDashboard.title", "Group Dashboard")}</h1>
          <p className={styles.lede}>
            {t(
              "dashboard.groupDashboard.lede",
              "Group volumes over the last 24 hours and the state of every company's connection.",
            )}
          </p>
        </div>
        {data?.lastDocumentAt ? (
          <span className={styles.stamp}>
            {t("dashboard.groupDashboard.lastDocument", "Last document")} {dateTime(data.lastDocumentAt)}
          </span>
        ) : null}
      </div>

      {summary.isError ? (
        <Notice kind="fail">
          <div className="row">
            <span className="grow">
              {t("dashboard.groupDashboard.summaryLoadError", "The group summary could not be loaded.")}
            </span>
            <button type="button" className="btn btn-sm" onClick={() => void summary.refetch()}>
              {t("dashboard.groupDashboard.retry", "Retry")}
            </button>
          </div>
        </Notice>
      ) : data ? (
        <>
          <StatRow summary={data} />
          <StageStrip counts={data.stageCounts} />
        </>
      ) : null}

      {data && data.entities.live === 0 ? (
        <Notice kind="info">
          <div className="row">
            <span className="grow">
              {t("dashboard.groupDashboard.noCompaniesLive", "No companies are live yet")}
            </span>
            <Link className="link" to="/companies">
              {t("dashboard.groupDashboard.setUpCompany", "Set up a company")}
            </Link>
          </div>
        </Notice>
      ) : null}

      <div className={styles.split}>
        <section className="card card-tight">
          <div className="card-head">
            <h2 className="grow">
              {t("dashboard.groupDashboard.companiesConnected", "Companies connected to the hub")}
            </h2>
            <Link className="link" to="/companies">
              {t("dashboard.groupDashboard.viewAll", "View all")}
            </Link>
          </div>
          {entities.isError ? (
            <div className="card-body">
              <Notice kind="fail">
                {t("dashboard.groupDashboard.companyListLoadError", "The company list could not be loaded.")}
              </Notice>
            </div>
          ) : (
            <HealthTable entities={entities.data ?? []} />
          )}
        </section>
        {data ? (
          <AspHealthCard connection={data.aspConnection} breaker={data.aspBreaker} />
        ) : null}
      </div>
    </>
  );
}
